import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

/**
 * Open unit trust fund account (generic)
 */
export const openUnitTrustFundAccount = createAction(
  '[Invest] Open Unit Trust Fund Account',
  props<{ payload: any; extraDetails?: any; fundShareClassCode: string; fundName?: string }>()
);

export const openUnitTrustFundAccountSuccess = createAction(
  '[Invest] Open Unit Trust Fund Account Success',
  props<{ accountDetails: any; fundShareClassCode: string; fundName?: string }>()
);

export const openUnitTrustFundAccountFailure = createAction(
  '[Invest] Open Unit Trust Fund Account Failure',
  props<{ error: HttpErrorResponse | string; fundShareClassCode: string; fundName?: string }>(),
);

/**
 * Get unit trust account transactions
 */

export const fetchUnitTrustAccountTransactions = createAction(
  '[Invest] Get Unit Trust Account Transactions ',
  props<{ payload: any; journeyType?: 'secondary' | 'savings' }>()
);

export const clearUnitTrustTransactions = createAction('[Invest] Clear Unit Trust Transactions');

export const fetchUnitTrustAccountTransactionsSuccess = createAction(
  '[Invest] Get Unit Trust Account Transactions Success',
  props<{ transactions: any }>()
);

export const fetchUnitTrustAccountTransactionsFailure = createAction(
  '[Invest] Get Unit Trust Account Transactions Failure',
  props<{ error: HttpErrorResponse }>(),
);


/**
 * Open a Savings Account
 */

export const openSavingsAccount = createAction(
  '[Invest] Open Savings Account ',
  props<{ payload: any; journeyType?: 'secondary' | 'savings' }>()
);

export const openSavingsAccountSuccess = createAction(
  '[Invest] Open Savings Account Success',
  props<{ accountDetails: any }>()
);

export const openSavingsAccountFailure = createAction(
  '[Invest] Open Savings Account Failure',
  props<{ error: HttpErrorResponse | string }>(),
);

export const getSavingsAccountParams = createAction(
  '[Invest] Get Savings Account Params'
);

export const getSavingsAccountParamsSuccess = createAction(
  '[Invest] Get Savings Account Params Success',
  props<{ savingsAccountParams: any }>()
);

export const getSavingsAccountParamsFailure = createAction(
  '[Invest] Get Savings Account Params Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Get unit trust account statement
 */
export const getUnitTrustAccountStatement = createAction(
  '[Invest] Get Unit Trust Account Statement',
  props<{ payload?: any }>()
);

export const getUnitTrustAccountStatementSuccess = createAction(
  '[Invest] Get Unit Trust Account Statement Success',
  props<{ statement: any[] }>()
);

export const getUnitTrustAccountStatementFailure = createAction(
  '[Invest] Get Unit Trust Account Statement Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Withdraw from trust account
 */
export const withdrawFromUnitTrustAccount = createAction(
  '[Invest] Withdraw from Unit Trust Account',
  props<{ payload: any }>()
);

export const withdrawFromUnitTrustAccountSuccess = createAction(
  '[Invest] Withdraw from Unit Trust Account Success',
  props<{ accountDetails: any[] }>()
);

export const withdrawFromUnitTrustAccountFailure = createAction(
  '[Invest] Withdraw from Unit Trust Account Failure',
  props<{ error: HttpErrorResponse }>(),
);

// get unit trust account details
export const getUnitTrustAccountDetails = createAction(
  '[Invest] Get Unit Trust Account Details',
  props<{ accountNumber?: string }>()
);
export const getUnitTrustAccountDetailsSuccess = createAction(
  '[Invest] Get Unit Trust Account Details Success',
  props<{ accountDetails: any }>()
);
export const getUnitTrustAccountDetailsFailure = createAction(
  '[Invest] Get Unit Trust Account Details Failure',
  props<{ error: HttpErrorResponse }>(),
);

// Fetch unit trust accounts
export const fetchUnitTrustAccounts = createAction(
  '[Invest] Fetch Unit Trust Accounts',
  props<{ Channel: string }>()
);

export const fetchUnitTrustAccountsSuccess = createAction(
  '[Invest] Fetch Unit Trust Accounts Success',
  props<{ accounts: any[] }>()
);

export const fetchUnitTrustAccountsFailure = createAction(
  '[Invest] Fetch Unit Trust Accounts Failure',
  props<{ error: HttpErrorResponse }>(),
);

// Fetch unit trust fact sheets
export const fetchUnitTrustFactSheets = createAction(
  '[Invest] Fetch Unit Trust Fact Sheets'
);

export const fetchUnitTrustFactSheetsSuccess = createAction(
  '[Invest] Fetch Unit Trust Fact Sheets Success',
  props<{ factSheets: any[] }>()
);

export const fetchUnitTrustFactSheetsFailure = createAction(
  '[Invest] Fetch Unit Trust Fact Sheets Failure',
  props<{ error: HttpErrorResponse }>(),
);
